import Stats from './Stats';
import RecenTrades from './RecentTraders';
import Charts from './Chart';
import classNames from 'classnames';
import Graph from './Graph';
import { Theme, useMediaQuery } from '@mui/material';

export default function Home() {
	const isLg = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

	return (
		<div
			className={classNames('flex-auto flex flex-col', 'gap-2 sm:gap-4 md:gap-x-2 md:grid lg:gap-x-6 lg:gap-y-9')}
			style={{
				gridTemplateAreas: '"stats charts charts" "graph graph recent"',
				gridTemplateColumns: '290px 1fr 270px',
				gridTemplateRows: 'auto 756px',
			}}
		>
			<div
				className={classNames('border border-borderPrimary bg-backgroundPrimary')}
				style={{ gridArea: 'stats' }}
			>
				<Stats />
			</div>
			<div className='border border-borderPrimary bg-backgroundPrimary' style={{ gridArea: 'charts' }}>
				<Charts />
			</div>
			{ !isLg && ( <div className='border border-borderPrimary bg-backgroundPrimary' style={{ gridArea: 'graph', minHeight: 750 }}>
				<Graph />
			</div> ) }
			<div className='border border-borderPrimary bg-backgroundPrimary overflow-hidden' style={{ gridArea: 'recent' }}>
				<RecenTrades />
			</div>
		</div>
	);
}
